import type { ReactStoryblokComponent } from "types/storyblok";
import RichtextAdapter from "../RichtextAdapter";
import contentStyles from "./Content.styles";
import type { ContentAdapterProps } from "./Content.d";

const ContentAdapter = ({ blok: { content } }: ReactStoryblokComponent<ContentAdapterProps>) => (
  <RichtextAdapter content={content} customStyles={contentStyles} />
);

export default ContentAdapter;
